import React from "react";
import { addLocaleData, IntlProvider, injectIntl, FormattedTime } from "react-intl";
import { Glyphicon, Media, OverlayTrigger, Tooltip } from "react-bootstrap";
import { CHAT_DEFAULT_BODY } from "./constants.js";
import Text from "react-format-text";
import { Twemoji, toArray } from "react-emoji-render";

const emojiOptions = {
  convertShortnames: true,
  convertUnicode: true,
  convertAscii: true,
  style: {
    height: 25,
    width: 25
  }
};

class Message extends React.Component {
  constructor(props) {
    super(props);
    this.renderMessage = this.renderMessage.bind(this);
  }

  render() {
    return <div>{this.props.message.body != CHAT_DEFAULT_BODY ? this.renderMessage() : ""}</div>;
  }

  renderMessage() {
    let message = this.props.message;
    let fromCurrentUser = message.sender.id === this.props.currentUser.id;
    let profilePhoto = message.sender.profilePhotoUrl;

    const senderNameTooltip = (
      <Tooltip id={"message-" + message.id + "-sender"}>
        <strong>{message.sender.name}</strong>
      </Tooltip>
    );

    const { intl } = this.props;
    return (
      <Media className="message">
        {fromCurrentUser ? (
          ""
        ) : (
          <Media.Left>
            <OverlayTrigger placement="top" overlay={senderNameTooltip}>
              <span>
                <div className="online-badge">
                  <img className="img-rounded" width={32} height={32} src={profilePhoto} />
                  <div className={`cute-badge out-badge ${message.sender.online ? "on" : "off"}`} />
                </div>
              </span>
            </OverlayTrigger>
          </Media.Left>
        )}
        <Media.Body className={fromCurrentUser ? "text-right" : ""}>
          <span className={fromCurrentUser ? "response" : "client"}>
            {EmojisAndLineBreaks(toArray(message.body))}

            <span className="small text-semi-muted date">
              <FormattedTime value={message.updatedAt} hour12={true} />
            </span>
          </span>
        </Media.Body>
        {fromCurrentUser ? (
          <Media.Right>
            <OverlayTrigger placement="top" overlay={senderNameTooltip}>
              <span>
                <img className="img-rounded" width={32} height={32} src={profilePhoto} />
              </span>
            </OverlayTrigger>
          </Media.Right>
        ) : (
          ""
        )}
      </Media>
    );
  }
}

function EmojisAndLineBreaks(array) {
  let element;
  return (
    <div>
      {array.map((el, idx) => (
        <span key={idx}>
          {typeof el == "object" ? renderEmojis(el) : null}
          {typeof el == "string" && <Text>{el}</Text>}
        </span>
      ))}
    </div>
  );
}

function renderEmojis(el) {
  return <Twemoji text={el.props.children} className={"emoji"} />;
}

export default injectIntl(Message);
